<!-- 📎 Shared File Upload Component -->
<div class="form-group form-input-file">
  <input
    type="file"
    class="form-control btn-input"
    id="ecm-mat-file-upload-input"
    name="uploadFile"
    aria-labelledby="ecm-mat-file-upload-label"
    aria-describedby="ecm-mat-file-upload-format ecm-mat-file-upload-size ecm-mat-file-upload-count"
    [accept]="acceptedFileTypesString()"
    (change)="onFilesSelected($event)"
    [disabled]="disabled() || isMaxFilesReached()"
    [multiple]="multiple()"
  />

  <p id="ecm-mat-file-upload-format" class="attachment-format">
    Formats acceptés : {{ acceptedFileTypes().join(', ') }}
  </p>

  @if (attachedFiles().length > 0) {
    <ul class="attachments">
      @for (item of attachedFiles(); track $index; let i = $index) {
        <li class="attachment">
          <span class="file-name">{{ item.file.name }}</span>

          <span class="file-size">{{ item.file.size | fileSize }}</span>

          <button
            class="btn btn-icon"
            type="button"
            [attr.aria-label]="'Supprimer ' + item.file.name"
            [title]="'Supprimer ' + item.file.name"
            (click)="removeFile(i)"
          >
            <span class="icon icon-trash" aria-hidden="true"></span>
          </button>
        </li>
      }
    </ul>
  }

  @if (errorMessage()) {
    <div #fileUploadError class="alert-container alert-container-sm alert-danger" role="alert" tabindex="-1">
      <p class="alert">
        <span class="alert-icon" aria-hidden="true"></span>
        <label class="ob1-alert-title" for="ecm-mat-file-upload-input" [innerHTML]="errorMessage()"></label>
      </p>
    </div>
  }

  <p id="ecm-mat-file-upload-size" class="attachment-size small">
    Vous disposez de
    <span class="font-weight-bold"
      >{{ remainingSize() | number: '1.0-2' }} <span aria-hidden="true">Mo</span
      ><span class="visually-hidden">méga octets</span></span
    >
    d'espace libre.
  </p>

  @if (isMaxFilesReached()) {
    <p id="ecm-mat-file-upload-count" class="attachment-files">Nombre maximum de fichiers atteint.</p>
  } @else {
    <p id="ecm-mat-file-upload-count" class="attachment-files">
      Vous pouvez ajouter <span class="font-weight-bold">{{ remainingCount() }} pièce(s) jointe(s).</span>
    </p>
  }

  <label
    id="ecm-mat-file-upload-label"
    type="button"
    class="btn btn-secondary"
    for="ecm-mat-file-upload-input"
    [class.w-100]="isMobileWidth()"
  >
    {{ buttonLabel() }}
  </label>
</div>
